import { Button, ReplayOutlinedIcon } from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { ClearExamAssignmentFormModal } from '../clear-exam-assignment-form-modal';

export default function ClearExamAssignmentButton() {
  const [
    isClearExamAssignmentModalOpen,
    { open: openClearExamAssignmentModal, close: closeClearExamAssignmentModal },
  ] = useDisclosure(false);

  const handleClick = () => {
    openClearExamAssignmentModal();
  };

  return (
    <>
      <Button
        variant='outlined'
        color='secondary'
        startIcon={<ReplayOutlinedIcon />}
        onClick={handleClick}
      >
        Clear Assignment
      </Button>
      <ClearExamAssignmentFormModal
        open={isClearExamAssignmentModalOpen}
        onClose={closeClearExamAssignmentModal}
      />
    </>
  );
}
